import React, { useState, useEffect, useContext, useCallback, useRef } from "react";
import PageTitle from "../../Components/PageTitle";
import axios from "axios";
import Swal from "sweetalert2";
import { ConfigContext } from "../../Context/ConfigContext";
import { ContentLoader, NoRecords } from "../../Components/Shimmer";
import Select from "react-select";
import { NavLink, useParams } from "react-router-dom";
import { DateFormaterMonth } from "../../Components/GlobalFunctions";
import { handleDownloadOptions } from "../../Components/ExportData";


const PendingProjects = () => {
    const { apiURL, apiHeaderJson, apiHeaderFile, user_profile_id } = useContext(ConfigContext);
    const [selectOption, setSelectOption] = useState(null);
    const [projectData, setProjectData] = useState([]);
    const { project_id } = useParams()
    const [loadingList, setLoadingList] = useState(false)

    const handleSelectStatus = (selectedOption) => {
        setSelectOption(selectedOption ? selectedOption.value : '');
    };

    const options = [
        { value: 'pending', label: "Pending" },
        { value: 'approved', label: 'Approved' },
        { value: 'rejected', label: 'Rejected' }
    ];


    const getPendingProjects = async () => {
        try {
            setLoadingList(true)
            const headers = apiHeaderJson;
            const response = await axios.get(`${apiURL}api/GetDashboardForContractor`, { params: { contractor_id: user_profile_id }, headers });
            setProjectData(response.data?.data?.tabs?.total_pending_projects);
            setLoadingList(false)
        } catch (error) {
            console.log(error);

        }
        finally {
            setLoadingList(false)
        }

    }

    const handleDownload = (downloadType) => {
        const endpoint = `api/GetDashboardForContractor`;
        const params = {
            contractor_id: user_profile_id
        };

        const columns = [
            { header: "Project Name", width: 30 },
            { header: "Location", width: 35 },
            { header: "Start Date", width: 25 },
            { header: "End Date", width: 25 },
            { header: "Status", width: 25 },
        ];

        const mapRow = (data) => ({
            "Project Name": data?.project_title ?? '-',
            "Location": data?.project_address ?? "-",
            "Start Date": DateFormaterMonth(data?.project_start_date) ?? "-",
            "End Date": DateFormaterMonth(data?.project_end_date) ?? "-",
            "Status": Labels(data.project_status) ?? "-",
        });

        // Modify the response handling in handleDownloadOptions to get the correct data path
        const responseHandler = (response) => response.data?.data?.tabs?.total_pending_projects || [];

        handleDownloadOptions(endpoint, params, columns, mapRow, downloadType, apiURL, apiHeaderJson, responseHandler);
    };

    const Labels = (status) => {
        if (status === 0) {
            return "Pending"
        }
        if (status === 1) {
            return "Completed"
        }
        if (status === 2) {
            return "Cancelled"
        }
    }
    const Classes = (status) => {
        if (status === 0) {
            return "badge bg-warning-subtle text-warning "
        }
        if (status === 1) {
            return "badge bg-success-subtle text-success "
        }
        if (status === 2) {
            return "badge bg-danger-subtle text-danger "
        }
    }


    // const handlePrev = () => {
    //     if (prev) {
    //         setPage((prevPage) => prevPage - 1);
    //     }
    // };

    // const handleNext = () => {
    //     if (next) {
    //         setPage((prevPage) => prevPage + 1);
    //     }
    // };
    // const handleChange = (e) => {
    //     setPage(parseInt(e.target.value, 10));
    // };




    useEffect(() => {
        getPendingProjects()
    }, [])
    return (
        <div className='main-content'>
            <div className='page-content'>
                {
                    loadingList ? <ContentLoader /> :
                        <div className="container-fluid">
                            <PageTitle title={`Active Projects`} primary={`Home`} />
                            <div className="col-md-12">
                                <div className="card">
                                    <div
                                        className="card-header align-items-center d-flex justify-content-between"
                                        style={{
                                            background: "#000000",
                                        }}
                                    >
                                        <h4 className="card-title mb-0 flex-grow-1 text-white">All Active Projects List</h4>


                                    </div>
                                    <div className="card-header pt-0 pb-0" style={{ border: "none" }}>
                                        <div className="row align-items-center py-4 g-3">
                                            {/* Status Select - takes 4 columns on md screens, full width on mobile */}
                                            {/* <div className="col-md-4 col-12">
                                                <Select
                                                    options={options}
                                                    value={selectOption ? options.find(option => option.value === selectOption) : null}
                                                    onChange={handleSelectStatus}
                                                    placeholder="Please Select Status"
                                                />
                                            </div> */}

                                            <div className="col-md-9"></div>


                                            {/* Download Report Dropdown - takes 3 columns on md screens, full width on mobile */}
                                            <div className="col-md-3 col-12">
                                                <div className="dropdown d-flex justify-content-md-end">
                                                    <button
                                                        type="button"
                                                        className="btn btn-light btn-label waves-effect waves-light"
                                                        id="dropdownMenuLink4"
                                                        data-bs-toggle="dropdown"
                                                        aria-expanded="true"
                                                    >
                                                        <i className="ri-download-2-line label-icon align-middle fs-16 me-2" />
                                                        Download Report
                                                    </button>
                                                    <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuLink4">
                                                        <li><a className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => handleDownload('print')}><i className="ri-printer-line me-2 align-middle text-muted" />Print</a>
                                                        </li>
                                                        <li><a className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => handleDownload('pdf')}><i className="ri-file-pdf-line me-2 align-middle text-muted" />PDF</a>
                                                            <li><a className="dropdown-item" style={{ cursor: "pointer" }} onClick={() => handleDownload('excel')}><i className="ri-file-excel-2-line me-2 align-middle text-muted" />Excel</a>
                                                            </li>

                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="card-body">
                                            <div className="table-responsive table-card">
                                                <table
                                                    className={`table table-bordered table-stripped mb-0`}
                                                >
                                                    <thead className="table-light">
                                                        <tr>
                                                            <th className="text-center" width="35%">Project Name</th>
                                                            <th className="text-center" width="28%">Location</th>
                                                            <th className="text-center" width="18%">Start Date</th>
                                                            <th className="text-center" width="18%">End Date</th>
                                                            <th className="text-center" width="15%">Status</th>

                                                        </tr>
                                                    </thead>
                                                    {projectData.length !== 0 ? (
                                                        <tbody>
                                                            {
                                                                projectData.map((row) => (
                                                                    <tr key={row.category_id}>
                                                                        <td className="text-center">
                                                                            <NavLink to={`/ProjectProfile/${row.project_id}`}>{row?.project_title ?? '-'}</NavLink>
                                                                        </td>
                                                                        <td className="text-center">{row?.project_address ?? '-'}</td>
                                                                        <td className="text-center">{DateFormaterMonth(row?.project_start_date)}</td>
                                                                        <td className="text-center">{DateFormaterMonth(row?.project_end_date)}</td>
                                                                        <td className="text-center"><span className={Classes(row.project_status)}>{Labels(row.project_status)}</span></td>

                                                                    </tr>
                                                                ))}
                                                        </tbody>
                                                    ) : (
                                                        <tbody>
                                                            <tr>
                                                                <td colSpan="5">
                                                                    <NoRecords />
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    )}

                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                }
            </div>
        </div>
    )
}

export default PendingProjects